// Analytics próprio do site — anônimo, sem cookies de rastreio (LGPD)
const API_URL = process.env.REACT_APP_BACKEND_URL || '';
const BUSINESS_PHONE = '5516991378312';

export const getSiteSession = () => {
  try {
    let sid = sessionStorage.getItem('ft_site_session');
    if (!sid) {
      sid = (window.crypto && window.crypto.randomUUID)
        ? window.crypto.randomUUID()
        : `${Math.random().toString(36).slice(2)}${Date.now()}`;
      sessionStorage.setItem('ft_site_session', sid);
    }
    return sid;
  } catch {
    return `anon-${Date.now()}`;
  }
};

export const track = (type, data = {}) => {
  try {
    fetch(`${API_URL}/api/track`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ type, session_id: getSiteSession(), ...data }),
      keepalive: true,
    }).catch(() => {});
  } catch { /* silencioso */ }
};

// Conversão contada 1x por sessão por canal
export const trackConversion = (channel) => {
  try {
    if (sessionStorage.getItem(`ft_conv_${channel}`)) return;
    sessionStorage.setItem(`ft_conv_${channel}`, '1');
  } catch { /* segue mesmo assim */ }
  track('conversion', { channel });
};

const isBusinessWhatsApp = (url) =>
  typeof url === 'string' &&
  /wa\.me|api\.whatsapp\.com/.test(url) &&
  url.includes(BUSINESS_PHONE);

let installed = false;
// Captura cliques em qualquer link/botão de WhatsApp do site (anchor ou window.open)
export const initTracking = () => {
  if (installed) return;
  installed = true;
  document.addEventListener('click', (e) => {
    const a = e.target && e.target.closest ? e.target.closest('a[href]') : null;
    if (!a) return;
    if (isBusinessWhatsApp(a.href)) trackConversion('whatsapp');
    else if (/^tel:/i.test(a.getAttribute('href') || '')) trackConversion('phone');
  }, true);
  const origOpen = window.open.bind(window);
  window.open = (url, ...rest) => {
    if (isBusinessWhatsApp(url)) trackConversion('whatsapp');
    return origOpen(url, ...rest);
  };
};
